import React from 'react';
import { NavLink } from 'react-router-dom';
import _ from 'lodash';

import StatusBadge from '../../StatusBadge';
import { filterStatus, status_ru, status_ru_extra } from '../../../../helpers/passport';
import { getLookupObject } from '../../../../utils/table';
import { arrayStringRenderer, dateRenderer, floatRenderer } from '../../../../services/formatSvc';
import { getStickyColumns, styledCellSticky } from '../../../../helpers/table';
import Tooltip from '@mui/material/Tooltip';
import { History } from '@material-ui/icons';
import { isAdmin, isProjectAdmin } from '../../../../services/rolesSvc';
import Delete from '@material-ui/icons/Delete';
import FilterMultiSelect from "../../../table/FilterMultiSelect";
import { arrayToLookup } from '../../../../helpers/table';
import { FilterInput } from "../../../../helpers/table.jsx"

const getProjectLink = (proj) => (proj.strategyId
  ? `/strats/${proj.strategyId}${proj.portfId ? `/portfolios/${proj.portfId}` : ''}/projs/${proj.id}`
  : proj.policyId
    ? `/policies/${proj.policyId}/projs/${proj.id}`
    : '');

const arrayToLookupSortAlph = (values, valueField, titleField) => (values && values.length > 0
  ? Object.fromEntries(
    values
      .sort((a, b) => (a[titleField] === b[titleField] ? 0 : a[titleField] < b[titleField] ? -1 : 1))
      .map((v) => [v[valueField], v[titleField || valueField]]),
  )
  : {});

export const getColumns = (type, filters, externalLookups, setPassportHistoryModal, userCtx, canDeleteProj, setIsModalDeleteProj, projects, MTableFiltersRef) => {
  const onStrat = type === 'onStrat';
  const onPolicy = type === 'onPolicy';
  const onPortf = type === 'onPortf';


  const stickyColumns = getStickyColumns([
    {
      title: 'Действ.',
      width: 90,
      cellStyle: styledCellSticky(),
      headerStyle: styledCellSticky(),
      filterCellStyle: styledCellSticky(),
      render: (rowData) =>
        <div style={{display: 'flex', gap: '10px'}}>
          <Tooltip title='История версий'>
            <History style={{ color: '#0D6EFD', cursor: 'pointer' }} onClick={() => {
              setPassportHistoryModal({
                id: rowData.id,
                num: rowData.fullNumber,
                version: rowData.version,
                stratId: rowData.strategyId,
                policyId: rowData.policyId
              })
            }}/>
          </Tooltip>
          {
            (isProjectAdmin(userCtx, rowData.originId) || isAdmin(userCtx)) &&
            <Tooltip title='Удалить'>
              <Delete style={{ color: canDeleteProj(rowData) ? '#dc3545' : 'rgba(0,0,0,0.28)' , cursor: canDeleteProj(rowData) ? 'pointer' : 'default'}} onClick={() => {
                if (canDeleteProj(rowData)) {
                  setIsModalDeleteProj({
                    show: true,
                    value: rowData.id
                  });
                }
              }} />
            </Tooltip>
          }
          {rowData.labels.length > 0 && <Tooltip title={<div>
            {rowData.labels.map(label => <p>{label.name}</p>)}
          </div>}>
                <span style={{
                  color: '#0D6EFD',
                  fontSize: 18,
                  cursor: 'default'
                }}>#</span>
          </Tooltip>}
        </div>
    },
    {
      title: '№',
      field: 'fullNumber',
      minWidth: '80px',
      width: 80,
      filterComponent: ({ columnDef, onFilterChanged })=><FilterInput columnDef={columnDef} onFilterChanged={onFilterChanged} MTableFiltersRef={MTableFiltersRef} field="fullNumber" />
    },
    {
      title: 'Наименование проекта',
      field: 'name',
      minWidth: '400px',
      render: (rowData) => <NavLink to={getProjectLink(rowData)}>{rowData.name}</NavLink>,
      width: 400,
      filterComponent: ({ columnDef, onFilterChanged })=><FilterInput columnDef={columnDef} onFilterChanged={onFilterChanged} MTableFiltersRef={MTableFiltersRef} field="name" />
    },
    {
      title: 'Руководитель проекта',
      field: 'headName',
      minWidth: '200px',
      width: 200,
      lookup: arrayToLookup('headName', projects),
      filterComponent: FilterMultiSelect,
    },
  ], 0)
  return [
    ...stickyColumns,
    {
      title: 'Версия Цифрового паспорта',
      field: 'version',
      minWidth: '40px',
    },
    {
      title: 'Ключевое направление',
      field: 'policyAreaName',
      hidden: onStrat || onPortf,
      lookup: arrayToLookup('policyAreaName', projects),
      minWidth: '200px',
      filterComponent: FilterMultiSelect,
    },
    {
      title: 'Бюджет из средств гранта (план) (руб.)',
      field: 'fbBudget',
      minWidth: '220px',
      filtering: false,
      aggregated: true,
      render: (rowData) => floatRenderer(rowData.fbBudget),
    },
    {
      title: 'Бюджет из средств софинансирования (план) (руб.)',
      field: 'sfBudget',
      minWidth: '220px',
      filtering: false,
      aggregated: true,
      render: (rowData) => floatRenderer(rowData.sfBudget),
    },
    {
      title: 'Соглашение',
      field: 'agreements',
      render: (rowData) => arrayStringRenderer(rowData.agreements),
      minWidth: '200px',
      hidden: onPolicy,
      lookup: externalLookups?.agreements,
      customFilterAndSearch: (term, rowData) => term.length === 0 || rowData.agreements && _.intersection(term, rowData.agreements).length > 0,
    },
    {
      title: 'Тип финансирования',
      field: 'funding',
      hidden: onPolicy,
      render: (rowData) => arrayStringRenderer([...new Set(rowData.funding.map((item) => (item === 'С' ? 'Специальная' : 'Базовая')))]),
      lookup: { С: 'Специальная', Б: 'Базовая' },
      customFilterAndSearch: (term, rowData) => term.length === 0 || rowData.funding && _.intersection(term, rowData.funding).length > 0,
    },
    {
      title: 'Код подраздела БК',
      field: 'bcCodes',
      minWidth: '150px',
      hidden: onPolicy,
      render: (rowData) => arrayStringRenderer(rowData.bcCodes),
      lookup: externalLookups?.bcCodes,
      customFilterAndSearch: (term, rowData) => term.length === 0 || rowData.bcCodes && _.intersection(term, rowData.bcCodes).length > 0,
    },
    {
      title: 'Дата начала проекта',
      field: 'startDate',
      minWidth: '120px',
      render: (rowData) => dateRenderer(rowData.startDate),
    },
    {
      title: 'Дата окончания проекта',
      field: 'endDate',
      minWidth: '120px',
      render: (rowData) => dateRenderer(rowData.endDate),
    },
    {
      title: 'Мероприятие Постановления № 729',
      field: 'letters',
      minWidth: '120px',
      hidden: onPolicy,
      render: (rowData) => arrayStringRenderer(rowData.letters),
      lookup: filters?.letters,
      _meta: {
        // lookup: true, // Invalid prop `columns[0].lookup` of type `boolean` supplied to `MaterialTable`, expected `object`
        customLookupObject: (data) => Object.fromEntries(_.uniq(data.filter((r) => r.letters).map((r) => r.letters).flat()).map((l) => [l, l])),
      },
      customFilterAndSearch: (term, rowData) => term.length === 0 || rowData.letters && _.intersection(term, rowData.letters).length > 0,

    },
    {
      title: 'Статус',
      field: 'status',
      lookup: status_ru_extra,
      minWidth: 200,
      render: ({ status }) => <StatusBadge type="proj" width={140} status={status} />,
      customFilterAndSearch: (term, rowData) => filterStatus(term, rowData),
    },
    {
      title: 'Стратегический проект',
      field: 'strategyNum',
      hidden: onStrat || onPortf,
      lookup: filters?.strategyNum,
      render: ({ strategyNum }) => <div style={{ textAlign: 'center' }}>{strategyNum}</div>,
      _meta: {
        // lookup: true,  // Invalid prop `columns[0].lookup` of type `boolean` supplied to `MaterialTable`, expected `object`
        customLookupObject: (data) => ({ 0: 'Нет', ...arrayToLookupSortAlph(data.filter((r) => r.strategyId), 'strategyId', 'strategyNum') }),
      },
      customFilterAndSearch: (term, rowData) => term.length === 0 || term.includes((rowData.strategyId || 0).toString()),
    },
    {
      title: 'Тип проекта',
      field: 'typeId',
      minWidth: '200px',
      lookup: externalLookups?.projTypes,
      // _meta: {
      //     lookup: true,
      //     customLookupDictionary: (data) => Object.fromEntries(_.uniq(data.filter(r => r.letters).map(r => r.letters).flat()).map(l => [l, l]))
      // },
    },
    {
      title: 'Протокол ЭГ/ЦК',
      field: 'expertGroupProtocol',
      hidden: onStrat || onPortf,
      minWidth: '200px',
    },
    {
      title: 'Наименование портфеля',
      field: 'portfolio',
      minWidth: '300px',
      hidden: onPolicy || onPortf, // портфельные вроде не могут быть добавлены в политику
      render: ({ portfolio }) => (portfolio ? portfolio.name : null),
    },
  ];
};

export const getFilters = (data) => {
  const columnsMetadata = getColumns({})
    .filter((col) => col._meta && col._meta.lookup)
    .map((col) => ({ field: col.field, lookupLabelsDictionary: col._meta.lookupLabelsDictionary, customLookupObject: col._meta.customLookupObject }));

  return columnsMetadata.reduce((acc, col) => {
    const result = col.customLookupObject ? col.customLookupObject(data) : getLookupObject(data, col.field);
    if (col.lookupLabelsDictionary) {
      for (const key of Object.keys(result)) result[key] = col.lookupLabelsDictionary[key];
    }

    return { ...acc, [col.field]: result };
  }, {});
};
